const publicAuthActionPaths = new Set([
  '/',
  '/preview',
  '/preview/suites',
  '/preview/tests',
  '/preview/trends',
  '/features',
  '/use-cases',
  '/plans',
  '/cookie-policy',
  '/cookie-policy.html',
  '/privacy-policy',
  '/privacy-policy.html',
  '/terms-of-service',
  '/terms-of-service.html',
  '/acceptable-use-policy',
  '/acceptable-use-policy.html',
  '/privacy-requests',
]);

const standalonePublicDocumentPaths = new Set([
  '/pocket-phrasebook/privacy',
  '/pocket-phrasebook/support',
]);

export const shouldShowPublicAuthActions = (
  activePath: string,
  isEntryAuthFlow: boolean,
): boolean => {
  if (isEntryAuthFlow) return false;
  if (activePath.startsWith('/use-cases/')) return true;
  return publicAuthActionPaths.has(activePath);
};

export const isPublicNavLinkActive = (activePath: string, targetPath: string): boolean => {
  if (
    targetPath === '/preview/suites' &&
    (activePath === '/preview' || activePath.startsWith('/preview/'))
  ) {
    return true;
  }
  return activePath === targetPath || activePath.startsWith(`${targetPath}/`);
};

export const shouldUseStandalonePublicDocument = (activePath: string): boolean =>
  standalonePublicDocumentPaths.has(activePath);

export const shouldHidePublicFooter = (activePath: string, isEntryAuthFlow: boolean): boolean =>
  activePath.startsWith('/preview') || isEntryAuthFlow;
